import React, {Component} from 'react'
import {withRouter} from "react-router-dom";
import NewClaimMenu from "./newClaimMenu";
import {Grid, Icon, Button, Header, Image} from "semantic-ui-react";
import "./newClaims.css"
import {connect} from "react-redux";
import Footer from "../../footer";
import NewClaimSteps from "./newClaimSteps";
import {getNumberOfUploadsRequired} from "../../../utils/common";
import DOCUMENT_EXAMPLES from '../documentExamples/documentExampleConstant';
import DocumentExampleCard from '../documentExamples/documentExampleCard';
import {ClaimStepsLayout} from "../ClaimStepsLayout";
import { isMobile } from '../../../utils/utils';

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        claimant: state.newClaim.claimant,
        treatmentInfo: state.newClaim.treatmentInfo
    }
};

class UploadInstructions extends Component {
    constructor(props) {
        super(props);
        const {claimant} = this.props;
        if (!claimant) {
            console.warn("No user info")
            this.props.history.replace("/claims");
        }
    }

    onBackHandler = () => {
        this.props.history.replace("/claims/new/treatmentInfo");
    }

    onNext = () => {
        this.props.history.push("/claims/new/uploads")
    }

    render() {
        const button = <Button primary content="Next step" onClick={this.onNext}/>;
        const numberOfUploadsRequired = getNumberOfUploadsRequired(this.props.treatmentInfo)
        return (
            <React.Fragment>
                <ClaimStepsLayout className="documents-main-container" style={{justifyContent: "center"}}>
                    <NewClaimMenu onBack={this.onBackHandler} />
                    <NewClaimSteps activeStepIdx={1} />
                    <div style={{marginTop: "56px"}}>
                        <Grid container stackable columns={1} centered>
                            <Grid.Column className={"pageContent uploadInstructions"}>
                                <Header as={"h2"}>Now let's prepare your documents</Header>
                                <p style={{marginBottom: "40px", fontSize: "16px"}} className="neutral700Text">On the next step, you'll be asked to upload <b>at least {numberOfUploadsRequired} </b>
                                    supporting documents that help us understand the details of this claim
                                </p>
                                <div style={{fontFamily: "Raleway, sans-serif", fontWeight: "bold", lineHeight: "24px", fontSize: "16px", color: "#214E41", marginBottom: 16}}>
                                    Here's the type of information we are looking for—
                                </div>
                                <p style={{marginBottom: "8px"}} className="neutral700Text">
                                    <Icon enabled name='check' size='small' color="green" style={{marginRight: "16px"}}/>Details on the condition and care received
                                </p>
                                <p style={{marginBottom: "8px"}} className="neutral700Text">
                                    <Icon enabled name='check' size='small' color="green" style={{marginRight: "16px"}}/>When and where the condition was diagnosed and/or treated
                                </p>
                                <p className="neutral700Text" style={{marginBottom: "24px"}}>
                                    <Icon enabled name='check' size='small' color="green" style={{marginRight: "16px"}}/>The name of the person who was diagnosed
                                </p>
                                <div style={{fontFamily: "Raleway, sans-serif", fontWeight: "bold", lineHeight: "24px", fontSize: "16px", color: "#214E41" }}>
                                    This information can typically be found in a number of places, look for documents like—
                                </div>
                                <p className="uploadInstructions-description">
                                    <Image src={'https://brella-platform-assets.s3.amazonaws.com/brella/member/cameraicon.png'}  floated='left' verticalAlign='middle'/> Photos or scans of documents work just fine</p>
                                <div style={{display: 'flex', flexDirection:'row', justifyContent: "space-between", marginBottom: '16px', marginTop: '16px'}}>
                                    { DOCUMENT_EXAMPLES.map(documentExample => <DocumentExampleCard {...documentExample} />) }
                                </div>
                                <p><Icon enabled name='lightbulb outline' size="large" color="black" inverted /> <b>Pro tip:</b> <i>If your health care provider has a patient login portal, some of these documents can be found there.</i></p>
                            </Grid.Column>
                        </Grid>
                    </div>
                    <div style={{marginTop: isMobile ? "0px" : "100px"}}>
                        <Footer showTopFooter={true}
                            hasToDisplayCarrierDisclaimer={true}
                            button={button}
                        />
                    </div>
                </ClaimStepsLayout>
            </React.Fragment>
        )
    }
}

export default connect(mapStateToProps)(withRouter(UploadInstructions));
